import React, { useContext } from "react";

const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="red"
    >
      <path
        d="M6.41602 4.08464H7.58268V5.2513H6.41602V4.08464Z"
        fill={'red'}
      />
      <path
        d="M6.41602 6.41797H7.58268V9.91797H6.41602V6.41797Z"
        fill="red"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16602 7.0013C1.16602 3.7813 3.77934 1.16797 6.99935 1.16797C10.2194 1.16797 12.8327 3.7813 12.8327 7.0013C12.8327 10.2213 10.2194 12.8346 6.99935 12.8346C3.77934 12.8346 1.16602 10.2213 1.16602 7.0013ZM2.33268 7.0013C2.33268 9.5738 4.42683 11.668 6.99935 11.668C9.57187 11.668 11.666 9.5738 11.666 7.0013C11.666 4.4288 9.57187 2.33464 6.99935 2.33464C4.42683 2.33464 2.33268 4.4288 2.33268 7.0013Z"
        fill='red'
      />
    </svg>
  );
};

export default ErrorIcon;
